import { Link } from 'react-router-dom'
import { artworkApi } from '@/features/artworks/api/artworkApi'

/** An artwork thumbnail with name and artist, linking to the artwork page. */
export function ArtworkTile({
  artwork,
  footer,
  children,
}: {
  artwork: { id: number; name: string; artistName: string | null; status: string }
  footer?: React.ReactNode
  children?: React.ReactNode
}) {
  return (
    <div className="group relative">
      <Link to={`/app/artworks/${artwork.id}`}>
        <div className="aspect-square overflow-hidden rounded border bg-slate-100">
          <img
            src={artworkApi.getArtworkImageUrl(artwork.id)}
            alt={artwork.name}
            loading="lazy"
            className="h-full w-full object-cover transition group-hover:scale-105"
          />
        </div>
        <div className="mt-1 truncate text-xs font-medium">{artwork.name}</div>
        <div className="truncate text-[11px] text-slate-500">
          {artwork.artistName ?? '—'}
          {artwork.status !== 'PUBLISHED' && <span className="ml-1 text-amber-600">· {artwork.status.toLowerCase()}</span>}
        </div>
      </Link>
      {footer}
      {children}
    </div>
  )
}

/** "0.42" with a hint: how much a concept counts in search (1 = fully, 0 = not at all). */
export function WeightLabel({ weight, curated }: { weight: number | null | undefined; curated?: boolean }) {
  if (weight == null) return <span className="text-slate-400">—</span>
  const tone = weight < 0.25 ? 'text-rose-600' : weight < 0.5 ? 'text-amber-600' : 'text-emerald-700'
  return (
    <span className={`tabular-nums ${tone}`} title={curated ? 'Set by a curator' : 'Automatic: how rare the concept is across artworks'}>
      {weight.toFixed(2)}
      {curated && <span className="ml-0.5 text-[10px] text-slate-400">✎</span>}
    </span>
  )
}
